export default __webpack_public_path__ + "static/media/client6.2cebe2ed.jpg";